var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCommunityMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.4999L2.08333 10.7499C1.33094 9.24554 1.13843 7.52254 1.54025 5.88923C1.94207 4.25592 2.912 2.8189 4.27646 1.83533C5.64093 0.851763 7.31087 0.385841 8.98744 0.520944C10.664 0.656046 12.2378 1.38336 13.4272 2.57272C14.6165 3.76208 15.3438 5.33587 15.4789 7.01244C15.614 8.68902 15.1481 10.359 14.1646 11.7234C13.181 13.0879 11.744 14.0578 10.1107 14.4596C8.47735 14.8615 6.75435 14.6689 5.25 13.9166L0.5 15.4999Z",
    stroke: "#1A1D20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommunityMenu);
export default __webpack_public_path__ + "static/media/icon-community-menu.a92d068af7bb23221cd10c432b027d57.svg";
export { ForwardRef as ReactComponent };